import React, { useRef, useState } from "react";
import { Box, CardActionArea, Stack, Typography } from "@mui/material";

const ProjectCards = ({ project, setOpenModal, index }) => {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const handleMove = (e) => {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    setTilt({ x: (y - 0.5) * -6, y: (x - 0.5) * 6 }); // more exaggerated tilt 
  };

  return (
    <Box ref={ref} onMouseMove={handleMove} onMouseLeave={() => setTilt({ x: 0, y: 0 })}
      className="tactical-border cyber-clip"
      sx={{
        width: { xs: 320, md: 400 }, flexShrink: 0, position: "relative",
        transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
        willChange: "transform", transition: "border-color 0.3s ease, box-shadow 0.3s ease",
        bgcolor: "rgba(5, 8, 18, 0.9)",
        "&:hover": { borderColor: "rgba(0, 240, 255, 0.4)", zIndex: 10, boxShadow: "0 10px 30px rgba(0, 240, 255, 0.1)" }
      }}>
      
      <CardActionArea onClick={() => setOpenModal({ state: true, project })} sx={{ p: 4, height: 320, display: "flex", flexDirection: "column", alignItems: "flex-start", cursor: "none" }}>
        
        {/* Top Metadata */}
        <Stack direction="row" justifyContent="space-between" width="100%" mb={5}>
          <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#6b7582", fontSize: "0.7rem", letterSpacing: "0.15em" }}>
            FILE_0{index + 1} {"//"} {project.date || "UNKNOWN"}
          </Typography>
          <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "rgba(0, 240, 255, 0.4)", fontSize: "0.7rem", letterSpacing: "0.15em" }}>
            CLASSIFIED
          </Typography>
        </Stack>

        {/* Project Type */}
        <Typography className="sys-glitch" sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#00f0ff", fontSize: "0.6rem", letterSpacing: "0.2em", mb: 2, textTransform: "uppercase" }}>
          {project.category}
        </Typography>

        {/* Project Title */}
        <Typography sx={{ fontFamily: "'Inter', sans-serif", color: "#e6e8ec", fontSize: "2rem", fontWeight: 400, lineHeight: 1.1, mb: 1, ".MuiCardActionArea-root:hover &": { color: "#00f0ff", textShadow: "0 0 10px rgba(0,240,255,0.4)" }, transition: "all 0.3s" }}>
          {project.title}
        </Typography>

        {/* Action button */}
        <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#858d99", fontSize: "0.7rem", letterSpacing: "0.15em", mt: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          CLICK TO OPEN CASE FILE
          <Box sx={{ width: 0, height: 1, flex: 1, bgcolor: "transparent", transition: "all 0.3s ease", ".MuiCardActionArea-root:hover &": { bgcolor: "#00f0ff", ml: 2 } }} />
        </Typography>
      </CardActionArea>
    </Box>
  );
};

export default ProjectCards;
